import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=79eb01c6&scoped=true"
import script from "./NewComment.vue?vue&type=script&lang=js"
export * from "./NewComment.vue?vue&type=script&lang=js"
import style0 from "./NewComment.vue?vue&type=style&index=0&id=79eb01c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb01c6",
  null
  
)

export default component.exports